import React from 'react'
import { browserHistory, Route, Router } from 'react-router'
import Demande from './Page/Demande/'

export default _ =>
  <Router history={browserHistory}>
    <Route key={'key_reservation'} path="/restaurant/reservation" type={'reservation'} component={Demande} />
    <Route key={'key_demande'} path="/restaurant/demande" type={'demande'} component={Demande} />
  </Router>


// WEBPACK FOOTER //
// ./app/App/Module/Restaurant/index.js